/* globals jQuery, google, REACH */
/* eslint-disable @wordpress/no-global-active-element */

/**
 * External dependencies
 */
import CliboardJS from 'clipboard';

/**
 * Internal dependencies
 */
import './theme/css-animate-transition';
import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setFlagClass from './theme/set-flag-class';
import setupCarousels from './theme/carousels';
import { pauseVideos } from './theme/videos';
import mapStyles from './theme/map-style.json';
import setupAccordions from './theme/accordions';
import setupTabs from './theme/tabs';
import setupModals from './theme/modals';
import setupDirectoryModules from './theme/ajax-directory';
import setupSupernavMenus from './theme/supernav-menus';
import debounce from './theme/debounce';

jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	const $body = $( 'body' );

	// =========================
	// ! Supports Flagging
	// =========================

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! External Link Mandate
	// =========================

	document.querySelectorAll( 'a[href^="http"]' ).forEach( anchor => {
		if ( ! anchor.target && ! anchor.href.startsWith( window.location.origin ) ) {
			anchor.setAttribute( 'target', '_blank' );
			anchor.setAttribute( 'rel', 'noreferrer noopener' );
		}
	} );

	// =========================
	// ! Plugins
	// =========================

	// Dropdown widgets
	if ( 'customA11ySelect' in $.fn ) {
		$( 'select.dropdown' ).customA11ySelect();
	}

	// =========================
	// ! Markup Adjustments
	// =========================

	$( '[class*="is-colorscheme-"]' ).each( function() {
		const color = this.className.replace( /^.*is-colorscheme-(\w+).*$/, '$1' );

		let inverse = 'white';
		if ( color === 'white' || color === 'grey' ) {
			inverse = 'black';
		}

		this.dataset.inverse = inverse;
	} );

	$( '.reach-modal, .reach-alum-modal' ).appendTo( $body );

	// =========================
	// ! Toggle Buttons
	// =========================

	$body.on( 'click', '.js-toggle', function( event ) {
		const target = determineTarget( this );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, null, 'focus' );

			// For global styling that might be needed
			$body.toggleClass( `show-${ target.id }`, isOpen );
		}
	} );

	$( '.js-close' ).on( 'click', function() {
		toggleElement( this.closest( '[aria-hidden="false"]' ), false );
	} );

	document.addEventListener( 'click', event => {
		document.querySelectorAll( '.js-click-outside-to-close' ).forEach( element => {
			if ( ! element.contains( event.target ) ) {
				toggleElement( element.querySelector( '[aria-hidden="false"]' ), false );
			}
		} );
	} );

	$( '.reach-nav-picker' ).click( function( e ) {
		if ( e.target.closest( '.current-menu-item' ) ) {
			e.preventDefault();
		}

		$( this ).toggleClass( 'is-open' );
	} );

	// =========================
	// ! Imput Status Handling
	// =========================

	$( 'input, textarea, select' ).each( function() {
		if ( this.value !== '' && ! [ 'hidden', 'checkbox', 'radio' ].includes( this.type ) ) {
			$( this ).addClass( 'is-filled' );
		}
	} );

	$document.on( 'focus input', 'input, textarea, select', function() {
		if ( this.nodeName.toLowerCase() !== 'input' || ! [ 'hidden', 'checkbox', 'radio' ].includes( this.type ) ) {
			$( this ).toggleClass( 'is-filled', this.value !== '' );
			$( this ).removeClass( 'is-invalid' );
		}
	} );

	$document.on( 'change', 'input[type="file"]', function() {
		const $field = $( this ).parents( '.js-file' );
		const $caption = $field.find( '.js-file-name' );
		const $preview = $field.find( '.js-file-preview' );
		$field.add( this ).toggleClass( 'is-filled', this.files.length > 0 );
		$field.find( '.js-file-delete' ).val( 0 ); // reset delete flag

		if ( this.files.length === 0 ) {
			$caption.text( '' );
			$preview.attr( 'src', null );
			return;
		}

		const [ file ] = this.files;
		if ( REACH.uploadLimit && file.size > REACH.uploadLimit ) {
			/* eslint-disable-next-line no-alert */
			alert( `File must not exceed ${ REACH.uploadLimitText || `${ REACH.uploadLimit } bytes` }` );

			this.value = null;
			$field.add( this ).addClass( 'is-filled' );
			$caption.text( '' );
			$preview.attr( 'src', null );
			return;
		}

		$preview.attr( 'src', null );
		if ( file.type.match( /^image\// ) ) {
			$preview.attr( 'src', URL.createObjectURL( file ) );
		}

		$caption.text( file.name || '' );
	} );

	$document.on( 'click', '.js-file-clear', function() {
		const $field = $( this ).parents( '.js-file' );
		const $input = $field.find( 'input[type="file"]' );
		$input.val( null ).trigger( 'change' );

		const $flag = $field.find( '.js-file-delete' );
		$flag.val( 1 );
	} );

	$document.on( 'reset', 'form', function() {
		$( this ).find( 'input, textarea' ).removeClass( 'is-filled' );
		$( this ).find( '.js-file-name' ).text( '' );
	} );

	// =========================
	// ! Modals
	// =========================

	// Add classes to modals automatically
	$( '.reach-modal' ).addClass( 'js-modal' );
	$( '.reach-modal__close' ).addClass( 'js-modal-close' );
	$( '.reach-modal__frame' ).addClass( 'js-modal-backdrop' );

	setupModals( REACH.endpoints || [] );

	// =========================
	// ! Supernav Setup
	// =========================

	const pageHeader = document.querySelector( '.page-header' );
	const closeAll = setupSupernavMenus( pageHeader );

	document.querySelectorAll( '.mobilenav__close, .page-header__menu-toggle' ).forEach( toggle => {
		toggle.addEventListener( 'click', () => closeAll() );
	} );

	// =========================
	// ! Nav Handling
	// =========================

	$( '.menu-item-has-children' ).click( '> :is(a,button)', function() {
		$( this ).toggleClass( 'is-open' ).siblings().removeClass( 'is-open' );
	} );

	// =========================
	// ! Mobile Nav Handling - Symposium Page
	// =========================

	$( '.page-template-symposium .menu a' ).click( function() {
		toggleElement( 'menu' );
		document.body.classList.remove( 'show-menu' );
	} );

	// =========================
	// ! Typewriter Text
	// =========================

	document.querySelectorAll( '.js-typewriter' ).forEach( container => {
		const lines = JSON.parse( container.dataset.lines );
		let currentLine = 0;

		container.style.setProperty( 'min-height', container.offsetHeight + 'px' );

		function nextLine() {
			let lastUpdate = performance.now();
			let length = lines[ currentLine ].length;

			function typeOut() {
				if ( performance.now() - lastUpdate > 10 ) {
					lastUpdate = performance.now();
					if ( length === 0 ) {
						currentLine++;
						if ( currentLine > lines.length - 1 ) {
							currentLine = 0;
						}

						setTimeout( typeIn, 500 );
						return;
					}

					container.innerText = container.innerText.substr( 0, --length );
				}

				requestAnimationFrame( typeOut );
			}

			function typeIn() {
				if ( performance.now() - lastUpdate > 20 ) {
					lastUpdate = performance.now();
					if ( length > lines[ currentLine ].length ) {
						setTimeout( nextLine, lines[ currentLine ].length * 100 );
						return;
					}

					container.innerText = lines[ currentLine ].substr( 0, ++length );
				}

				requestAnimationFrame( typeIn );
			}

			typeOut();
		}

		setTimeout( nextLine, lines[ currentLine ].length * 100 );
	} );

	// =========================
	// ! Intersection Stuff
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		$body.addClass( 'supports-intersection-observer' );

		const $button = $( '.reach-menu-button' );

		if ( $button.length ) {
			const colorschemeObserver = new IntersectionObserver( changes => {
				let color;

				changes.forEach( change => {
					if ( change.isIntersecting ) {
						color = change.target.dataset.inverse;
					}
				} );

				if ( color ) {
					setFlagClass( $button[ 0 ], 'is-color', color );
				}
			}, {
				rootMargin: '0px 0px -100%',
			} );

			$( '[data-inverse]' ).each( function() {
				colorschemeObserver.observe( this );
			} );
		}

		const stickyObserver = new IntersectionObserver( ( [ e ] ) => {
			e.target.classList.toggle( 'is-stickied', e.intersectionRatio < 1 );
		}, {
			threshold: [ 1 ],
			rootMargin: '0% 0% 100% 0%',
		} );

		$( '.js-sticky' ).each( function() {
			stickyObserver.observe( this );
		} );

		// =========================
		// ! In-View Tracking
		// =========================

		const inviewTargets = new WeakMap();
		const inviewObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				if ( ! inviewTargets.has( change.target ) ) {
					inviewTargets.set( change.target, true );
					if ( change.isIntersecting || change.intersectionRatio > 0 || change.boundingClientRect.top < 0 ) {
						$( change.target ).removeClass( 'lazy' ).parents( '.lazy' ).removeClass( 'lazy' );
					}
				} else if ( change.isIntersecting || change.intersectionRatio > 0 ) {
					$( change.target ).addClass( 'in-view' ).parents( '.lazy' ).addClass( 'in-view' );
					$( change.target ).prevAll( '.lazy' ).addClass( 'in-view' ).children( '.lazy' ).addClass( 'in-view' );
				}
			} );
		}, {
			rootMargin: '-25% 0px 0px 0px',
		} );

		$( '.page-content, .reach-timeline__content, .reach-wrapper, .lazy-load-content' ).children().addClass( 'lazy' ).each( function() {
			inviewObserver.observe( this );
		} );

		// =========================
		// ! - Timeline Scroll Spy
		// =========================

		const $timelineNav = $( '.reach-timeline__nav' );
		const $timelineNavWrap = $( '.reach-timeline__nav__items' );
		const timelineNavOffset = $timelineNav.outerHeight() || 0;
		const $timelineLinks = $timelineNav.find( '.is-month a' );
		const $timelineTargets = $timelineLinks.map( function() {
			return document.querySelector( this.hash );
		} );

		let navScrollUpdate;

		const targetObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				$( change.target ).toggleClass( 'is-visible', change.isIntersecting );
			} );

			const match = $timelineTargets.filter( '.is-visible' )[ 0 ];
			if ( match ) {
				const $match = $timelineLinks.removeClass( 'is-current' )
					.filter( `a[href="#${ match.id }"]` )
					.addClass( 'is-current' );

				clearTimeout( navScrollUpdate );
				navScrollUpdate = setTimeout( () => {
					$timelineNavWrap[ 0 ].scrollTo( {
						top: 0,
						left: $match[ 0 ].offsetLeft - 60,
						behavior: 'smooth',
					} );
				}, 500 );
			}
		}, {
			rootMargin: `-${ timelineNavOffset }px 0px -25%`,
		} );

		$timelineTargets.each( function() {
			targetObserver.observe( this );
		} );

		// =========================
		// ! - Article Scroll Spy
		// =========================

		const headingObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				const link = document.querySelector( `a[href="#${ change.target.id }"]` );
				if ( link ) {
					if ( change.isIntersecting ) {
						link.classList.add( 'is-active-target' );
					} else {
						link.classList.remove( 'is-active-target' );
					}
				}
			} );
		}, {
			rootMargin: `0px 0px -25%`,
		} );

		$( '.reach-article' ).find( 'h2[id], h3[id]' ).each( function() {
			headingObserver.observe( this );
		} );
	}

	// =========================
	// ! Resize Stuff
	// =========================

	if ( typeof ResizeObserver !== 'undefined' ) {
		$body.addClass( 'supports-resize-observer' );

		function heightObserver( property ) {
			return new ResizeObserver( ( [ entry ] ) => {
				let { borderBoxSize } = entry;

				if ( borderBoxSize instanceof Array ) {
					( [ borderBoxSize ] = borderBoxSize );
				}

				document.documentElement.style.setProperty( property, borderBoxSize.blockSize + 'px' );
			} );
		}

		const header = document.querySelector( '.reach-header' );
		if ( header ) {
			heightObserver( '--header-height' ).observe( header );
		}

		const subheader = document.querySelector( '.reach-subheader__inner' );
		if ( subheader ) {
			heightObserver( '--subheader-height' ).observe( subheader );
		}

		function updateScrollStatus( target ) {
			const parent = target.parentElement;

			const horizontalScroll = target.scrollWidth > target.clientWidth;

			parent.classList.toggle( 'js-is-scrolled-left', horizontalScroll && target.scrollLeft <= 0 );
			parent.classList.toggle( 'js-is-scrolled-right', horizontalScroll && target.scrollLeft >= target.scrollWidth - target.clientWidth );
		}

		const overflowObserver = new ResizeObserver( entries => {
			entries.forEach( ( { target } ) => {
				const $target = $( target );
				const $parent = $target.parent();

				$parent.toggleClass( 'js-has-scrollable-horizontal', target.scrollWidth > target.clientWidth );

				updateScrollStatus( target );
			} );
		} );

		$( '.reach-subheader__content' ).each( function() {
			$( this ).before( $( '<button class="js-scroll-button js-scroll-left">Scroll Contents</button>' ).data( 'target', this ) );
			$( this ).after( $( '<button class="js-scroll-button js-scroll-right">Scroll Contents</button>' ).data( 'target', this ) );
			overflowObserver.observe( this );
		} ).scroll( function() {
			updateScrollStatus( this );
		} );

		$( '.js-scroll-button' ).click( function() {
			const target = $( this ).data( 'target' );

			if ( $( this ).hasClass( 'js-scroll-left' ) ) {
				target.scrollLeft -= target.clientWidth / 2;
			}
			if ( $( this ).hasClass( 'js-scroll-right' ) ) {
				target.scrollLeft += target.clientWidth / 2;
			}
		} );
	}

	// =========================
	// ! Peek-a-boo Nav Handling
	// =========================

	let lastScroll = 0;
	let lastDirection = null;
	let lastPastHeader = null;
	const headerThreshold = 170;

	$window.scroll( function() {
		const scroll = $window.scrollTop();
		const direction = scroll >= lastScroll ? 1 : -1;
		const pastHeader = scroll > headerThreshold;

		if ( direction !== lastDirection || pastHeader !== lastPastHeader ) {
			$body.toggleClass( 'animating-sticky-nav', pastHeader );
			$body.toggleClass( 'animating-sticky-nav--in', direction < 0 && pastHeader );
			$body.toggleClass( 'animating-sticky-nav--out', direction > 0 && pastHeader );
		}

		lastScroll = scroll;
		lastDirection = direction;
		lastPastHeader = pastHeader;
	} );

	// =========================
	// ! Scroller Buttons
	// =========================

	function makeScrollerButton( type ) {
		const button = document.createElement( 'div' );
		button.className = `reach-scroller__button ${ type }`;
		button.setAttribute( 'aria-hidden', true );
		return button;
	}

	document.querySelectorAll( '.reach-scroller' ).forEach( scroller => {
		const inner = scroller.querySelector( '.reach-scroller__inner' );
		const navWrap = scroller.querySelector( '.reach-scroller__buttons' ) || scroller.querySelector( '.reach-scroller__header' );
		const nextButton = makeScrollerButton( 'next' );
		const prevButton = makeScrollerButton( 'prev' );
		const buttons = [ nextButton, prevButton ];

		navWrap.append( nextButton, prevButton );

		prevButton.hidden = true;
		inner.addEventListener( 'scrollend', () => {
			nextButton.hidden = inner.scrollLeft + inner.offsetWidth >= inner.scrollWidth;
			prevButton.hidden = inner.scrollLeft === 0;
		} );

		let sampleItem = inner.firstElementChild;
		if ( ! scroller.classList.contains( 'full-width-items' ) ) {
			sampleItem = scroller.querySelector( '.reach-scroller__header' );
		}

		buttons.forEach( button => {
			button.addEventListener( 'click', () => {
				if ( button.classList.contains( 'next' ) ) {
					inner.scrollBy( {
						left: sampleItem.offsetWidth,
						behavior: 'smooth',
					} );
				} else {
					inner.scrollBy( {
						left: -1 * sampleItem.offsetWidth,
						behavior: 'smooth',
					} );
				}
			} );
		} );
	} );

	document.addEventListener( 'keyup', event => {
		if ( event.key === 'Tab' ) {
			const scroller = document.activeElement?.closest( '.reach-scroller__inner' );
			if ( scroller ) {
				document.activeElement.scrollIntoView( {
					behavior: 'smooth',
					block: 'nearest',
					inline: 'nearest',
				} );
			}
		}
	} );

	// =========================
	// ! Image Fullscreen Support
	// =========================

	function makeTakeoverButton( type ) {
		const button = document.createElement( 'button' );
		button.className = `reach-lightbox__nav-button ${ type }`;
		button.innerText = `${ type }`;
		return button;
	}

	const imageCollections = new WeakMap();

	let imageContainerCount = 0;
	$( '.wp-block-image[data-fullsize]' ).each( function() {
		const container = this.parentElement;
		if ( imageCollections.has( container ) ) {
			return;
		}

		const images = $( container ).children( '.wp-block-image[data-fullsize]' ).get();

		const takeoverId = `lightbox-${ imageContainerCount++ }`;

		const takeover = document.createElement( 'figure' );
		takeover.id = takeoverId;
		takeover.classList.add( 'reach-lightbox' );
		takeover.classList.add( 'js-modal' );

		// Add body/footer to takeover
		const takeoverBody = document.createElement( 'div' );
		takeoverBody.classList.add( 'reach-lightbox__body' );
		takeover.append( takeoverBody );
		const takeoverFooter = document.createElement( 'div' );
		takeoverFooter.classList.add( 'reach-lightbox__footer' );
		takeover.append( takeoverFooter );

		// Add controls to takeover
		const takeoverNav = document.createElement( 'div' );
		takeoverNav.classList.add( 'reach-lightbox__nav' );
		const nextButton = makeTakeoverButton( 'next' );
		const prevButton = makeTakeoverButton( 'prev' );
		const buttons = [ nextButton, prevButton ];

		takeoverNav.append( nextButton, prevButton );
		takeover.append( takeoverNav );

		// Add close button to takeover
		const collapse = document.createElement( 'button' );
		collapse.type = 'button';
		collapse.classList.add( 'reach-toggle' );
		collapse.classList.add( 'js-modal-close' );
		collapse.innerText = 'Close';
		takeover.append( collapse );

		images.forEach( ( image, index ) => {
			const img = image.querySelector( 'img' );
			const config = JSON.parse( image.dataset.fullsize || '{}' );

			const wrapper = document.createElement( 'div' );
			wrapper.classList.add( 'wp-block-image__frame' );
			img.before( wrapper );
			wrapper.append( img );

			const expand = document.createElement( 'button' );
			expand.type = 'button';
			expand.classList.add( 'reach-toggle' );
			expand.setAttribute( 'aria-controls', takeoverId );
			expand.innerText = 'View Full Size';
			wrapper.append( expand );

			const altImage = img.cloneNode();
			if ( config.url ) {
				altImage.src = config.url;
				altImage.width = config.width;
				altImage.height = config.height;
			}

			takeoverBody.append( altImage );
			takeoverFooter.append( img.cloneNode() );

			expand.addEventListener( 'click', function() {
				goToImage( index );
			} );
		} );

		let current = 0;
		const count = takeoverFooter.querySelectorAll( 'img' ).length;

		function goToImage( i ) {
			const galleryImages = takeoverBody.querySelectorAll( 'img' );
			const thumbnails = takeoverFooter.querySelectorAll( 'img' );

			const currentImage = galleryImages.item( i );
			[ ...galleryImages ].forEach( img => {
				img.setAttribute( 'aria-hidden', true );
			} );
			currentImage.setAttribute( 'aria-hidden', false );

			const currentThumbnail = thumbnails.item( i );
			[ ...thumbnails ].forEach( img => {
				img.setAttribute( 'aria-selected', false );
			} );
			currentThumbnail.setAttribute( 'aria-selected', true );
			currentThumbnail.scrollIntoView( { behavior: 'smooth', block: 'nearest', inline: 'start' } );

			current = i;
		}

		buttons.forEach( button => {
			button.addEventListener( 'click', function() {
				let next;
				if ( ( this ).classList.contains( 'prev' ) ) {
					next = current > 0 ? current - 1 : count - 1;
				} else {
					next = current < count - 1 ? current + 1 : 0;
				}
				goToImage( next );
			} );
		} );

		const gallery = [ ...takeoverFooter.children ];

		takeoverFooter.addEventListener( 'click', event => {
			const _index = gallery.indexOf( event.target );
			if ( _index >= 0 ) {
				goToImage( _index );
			}
		} );

		takeoverFooter.scrollLeft = 0;
		document.body.append( takeover );

		imageCollections.set( container, takeover );
	} );

	// =========================
	// ! Accordion
	// =========================

	// Add classes to accordion blocks automatically
	$( '.reach-accordion-group, .reach-tab-set' ).addClass( 'js-accordion-group' );
	$( '.reach-accordion__toggle, .reach-tab-header__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.reach-accordion__content, .reach-tab-panel' ).addClass( 'js-accordion-content' );

	const accordionEndpoints = setupAccordions( REACH?.accordionEndpoints ?? [] );

	$( '.reach-section-nav-wrapper' ).on( 'click', function( event ) {
		if ( ! event.target.closest( '.reach-section-nav__link' ) ) {
			return;
		}
		const endpointMatch = accordionEndpoints.find( ( { name, mediaQuery } ) => {
			return this.classList.contains( `js-${ name }-accordion` ) && mediaQuery.matches;
		} );
		if ( ! endpointMatch ) {
			toggleElement( this, false );
		}
	} );

	// =========================
	// ! Tab Set
	// =========================

	// Add classes to tab/tabset blocks automatically
	$( '.reach-tab-set' ).addClass( 'js-tab-set' );
	$( '.reach-tab-set__nav-item' ).addClass( 'js-tab' );
	$( '.reach-tab-panel' ).addClass( 'js-tab-panel' );

	// Mark first tab as auto-open accordion
	$( '.reach-tab-set' ).each( function() {
		$( this ).find( '.reach-tab-header__toggle' ).first().addClass( 'auto-open' );

		// Animate to the target tab
		const $nav = $( this ).find( '.reach-tab-set__nav' );
		const $navItems = $( this ).find( '.reach-tab-set__nav-item' );
		$nav.css( '--current-tab-offset', $navItems.first().position().left + 'px' );
		$nav.css( '--current-tab-width', $navItems.first().width() + 'px' );

		$navItems.on( 'click', function() {
			const toggle = $( this );

			$nav.css( '--current-tab-offset', $( toggle ).position().left + 'px' );
			$nav.css( '--current-tab-width', $( toggle ).width() + 'px' );
		} );
	} );

	setupTabs();

	// =========================
	// ! Flyouts & Modals
	// =========================

	// Add hitarea divs, move to end of body
	$( '.reach-flyout, .reach-modal, .reach-popup' ).prepend( '<div class="js-hitarea"></div>' ).appendTo( 'body' );

	// Hitarea handling
	$document.on( 'click', '.js-hitarea', function() {
		toggleElement( this.parentElement.id, false );
	} );

	// Pause any videos when hiding a carousel
	$( '.reach-modal' ).on( 'toggle-off', function() {
		pauseVideos( this );
	} );

	// =========================
	// ! Video Blocks
	// =========================

	$( '.reach-video__media' ).click( function( e ) {
		e.preventDefault();
		const url = $( this ).data( 'embed' );

		const $iframe = $( `<div class="reach-video__media"><iframe src="${ url }" frameborder="0" allowfullscreen></iframe></div>` );

		$iframe.insertAfter( this );
		$( this ).remove();
	} );

	// =========================
	// ! Gallery Carousels
	// =========================

	// Prep carousel galleries for functionality
	$( '.reach-carousel' ).each( function() {
		$( this ).find( '.wp-block-gallery' ).addClass( 'js-carousel-track' );
		$( this ).find( '.wp-block-image' ).addClass( 'js-carousel-slide' );
	} );

	function syncCarouselExpandButton( { carousel, slides, currentIndex = 0 } ) {
		const slide = slides.item( currentIndex );
		if ( ! slide ) {
			return;
		}

		const toggle = slide.querySelector( '.reach-toggle' );

		const button = carousel.querySelector( '.js-carousel-expand' );

		if ( toggle && button ) {
			// button.setAttribute( 'aria-controls', toggle.getAttribute( 'aria-controls' ) );

			button.addEventListener( 'click', function() {
				toggle.click();
			} );
		}
	}

	setupCarousels( {
		animate: true,
		onReady: syncCarouselExpandButton,
		onSlideChange: syncCarouselExpandButton,
	} );

	// =========================
	// ! Slick Quote Carousel
	// =========================

	$( '.reach-quote-carousel' ).each( function() {
		const $carousel = $( this );
		const $slides = $carousel.find( '.reach-quote-carousel__slides' );
		const $count = $carousel.find( '.reach-quote-carousel__count' );
		const $prev = $carousel.find( '.reach-quote-carousel__arrow.is-prev' );
		const $next = $carousel.find( '.reach-quote-carousel__arrow.is-next' );

		function updateSlideCount( slick ) {
			$count.text( parseInt( slick.currentSlide + 1 ) + '/' + slick.slideCount );
		}

		$slides.slick( {
			centerMode: true,
			centerPadding: 0,
			slidesToShow: 1,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 15000,
			prevArrow: $prev,
			nextArrow: $next,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						centerMode: false,
						slidesToShow: 1,
					},
				},
			],
		} );

		$slides.on( 'init', function( event, slick ) {
			updateSlideCount( slick );
		} );

		$slides.on( 'afterChange', function( event, slick ) {
			updateSlideCount( slick );
		} );
	} );

	// =========================
	// ! Map Modules
	// =========================

	$( '.js-map' ).each( function() {
		const $map = $( this );
		const $canvas = $map.find( '.js-map-canvas' );
		const $filters = $map.find( '.js-map-filter' );
		const $tooltip = $( '<div class="js-map-tooltip"></div>' ).appendTo( $canvas );

		$canvas
			.on( 'mouseenter', () => $tooltip.addClass( 'in' ) )
			.on( 'mouseleave', () => $tooltip.addClass( 'in' ) )
			.on( 'mouseenter mousemove', ( { originalEvent: { target, offsetX, offsetY } } ) => {
				const $shape = $( target ).closest( '.js-map-shape' );

				$tooltip
					.text( $shape.attr( 'title' ) || null )
					.css( {
						top: offsetY + 'px',
						left: offsetX + 'px',
					} );
			} );

		const $itemsWrap = $map.find( '.js-map-items' );
		const $items = $map.find( '.js-map-item, .js-map-marker' );
		const $shapes = $map.find( '.js-map-shape' );
		const $populatedShapes = $shapes.filter( '.has-items' );
		const $groups = $map.find( '.js-map-group' );

		if ( $map.find( '.js-map-group' ).length === 0 ) {
			$map.find( '.js-map-item' ).sort( ( a, b ) => {
				if ( a.dataset.country === b.dataset.country ) {
					return a.dataset.post > b.dataset.post ? 1 : -1;
				}
				return a.dataset.country > b.dataset.country ? 1 : -1;
			} ).appendTo( $itemsWrap );
		}

		function filterItems() {
			$items.each( function() {
				const item = this;
				let isExcluded = false;

				$filters.each( function() {
					const filter = this;
					const value = $( item ).data( filter.name );
					if ( filter.value !== 'all' && typeof value !== 'undefined' && value !== filter.value ) {
						isExcluded = true;
					}
				} );

				$( this ).attr( 'hidden', isExcluded );
			} );

			$populatedShapes.each( function() {
				$( this ).toggleClass( 'excluded', $items.filter( `[data-country="${ this.dataset.country }"]:not([hidden])` ).length === 0 );
			} );

			$groups.each( function() {
				$( this ).attr( 'hidden', $( this ).find( '.js-map-item:not([hidden])' ).length === 0 );
			} );

			$filters.each( function() {
				const name = this.name;
				const selected = this.value;

				$( this ).find( 'option' ).each( function() {
					this.disabled = selected === 'all' && this.value !== 'all' && $items.filter( `[data-${ name }="${ this.value }"]:not([hidden])` ).length === 0;
				} );

				$( this ).closest( '.reach-filter' ).find( '.custom-a11yselect-option' ).each( function() {
					this.hidden = selected === 'all' && this.dataset.val !== 'all' && $items.filter( `[data-${ name }="${ this.dataset.val }"]:not([hidden])` ).length === 0;
				} );
			} );
		}

		$filters.on( 'change', filterItems );

		// When hovering items/markers, highlight associated country on map
		$items.hover( function() {
			const country = $( this ).data( 'country' );
			const post = $( this ).data( 'post' );

			if ( country ) {
				$shapes.removeClass( 'is-focused' ).filter( `[data-country="${ country }"]` ).addClass( 'is-focused' );
			}

			// Assume focused class away from other items
			if ( post ) {
				const $item = $items.removeClass( 'is-focused' ).filter( `[data-post="${ post }"]` ).addClass( 'is-focused' );
				if ( $( this ).hasClass( 'js-map-marker' ) ) {
					$item.filter( '.js-map-item' ).get( 0 )?.scrollIntoView( { block: 'nearest', behavior: 'smooth' } );
				}
			}
		} );

		// When hovering country shapes, highlight assogiated items/markers
		$shapes.on( 'mouseenter', function() {
			const country = $( this ).data( 'country' );

			$map.find( '[data-country]' ).removeClass( 'is-focused' );
			$map.find( `[data-country="${ country }"]` ).addClass( 'is-focused' );
		} );

		// Clicking on a country shape triggers the click of the
		// corresponding item, IF it's not for a specific post
		$shapes.click( function() {
			const country = $( this ).data( 'country' );

			const $item = $items.filter( `[data-country="${ country }"]` );
			if ( $item.length !== 1 || $item.filter( '[data-post]' ).length > 0 ) {
				return;
			}

			$item[ 0 ].click();
		} );

		// Clicking a marker triggers a click on the corresponding item
		$map.find( '.js-map-marker' ).click( function() {
			const post = $( this ).data( 'post' );
			$map.find( `.js-map-item[data-post="${ post }"] [aria-controls]` ).click();
		} );

		// Toggle focus styling if hovering the canvas or list
		const $focusContainers = $( '.js-map-canvas, .js-map-items' );
		$focusContainers.hover( function() {
			$focusContainers.addClass( 'has-focus-within' );
		}, function() {
			$focusContainers.removeClass( 'has-focus-within' );
			// reset focused items when leaving either area
			$map.find( '.is-focused' ).removeClass( 'is-focused' );
		} );
	} );

	// =========================
	// ! Timeline Module
	// =========================

	if ( typeof ResizeObserver !== 'undefined' ) {
		const entryHeightObserver = new ResizeObserver( ( [ entry ] ) => {
			let { borderBoxSize } = entry;

			if ( borderBoxSize instanceof Array ) {
				( [ borderBoxSize ] = borderBoxSize );
			}

			entry.target.style.setProperty( '--height', borderBoxSize.blockSize + 'px' );
		} );

		$( '.reach-timeline-entry' ).each( function() {
			entryHeightObserver.observe( this );
			this.style.setProperty( '--height', this.getBoundingClientRect().height + 'px' );
		} );
	}

	$( '.reach-timeline' ).each( function() {
		// const $headings = $( this ).find( '.reach-timeline-heading' );
		const $entries = $( this ).find( '.reach-timeline-entry' );

		// const colors = [ 'teal', 'blue', 'red' ];
		// $headings.each( function( i ) {
		// 	$( this ).nextUntil( '.reach-timeline-heading' ).addClass( `is-color-${ colors[ i % 3 ] }` );
		// } );

		$entries.each( function( i ) {
			$( this ).addClass( 'is-color-teal' );
			$( this ).addClass( i % 2 ? 'is-even' : 'is-odd' );
			$( this ).toggleClass( 'first-in-section', ! $( this ).prev().hasClass( 'reach-timeline-entry' ) );
			$( this ).toggleClass( 'last-in-section', ! $( this ).next().hasClass( 'reach-timeline-entry' ) );
			$( this ).prepend( '<div class="reach-timeline-entry__marker"></div>' );
		} );
	} );

	// =========================
	// ! Footnote tooltip
	// =========================

	$( '.fn' ).each( function() {
		const number = this.textContent;
		const text = document.getElementById( this.dataset.fn ).innerHTML;

		const $tooltip = $( `<div class= footnote-tooltip>
			<p class="footnote-tooltip__label">Footnote ${ number }</p>
			<p class="footnote-tooltip__content">${ text }</p>
			<p class="footnote-tooltip__help">(Click to scroll to footnotes)</p>
		</div>` );

		$tooltip.appendTo( document.body );

		$( this ).mouseenter( function( event ) {
			$( '.footnote-tooltip' ).removeClass( 'in' );
			$tooltip.css( {
				top: event.pageY,
				left: event.pageX,
			} ).addClass( 'in' );
		} ).mousemove( function( event ) {
			$tooltip.css( {
				top: event.pageY,
				left: event.pageX,
			} );
		} ).mouseleave( function() {
			$tooltip.removeClass( 'in' );
		} );
	} );

	// =========================
	// ! Embed Placeholders
	// =========================

	$( '.js-embed-trigger' ).one( 'click', function() {
		const $parent = $( this ).closest( '.js-embed' );
		const $wrapper = $parent.find( '.js-embed-wrapper' );
		const $content = $parent.find( '.js-embed-content' );

		$wrapper.empty().append( $content.html() );
		$content.remove();
		$( this ).remove();
	} );

	// =========================
	// ! Google Map Handling
	// =========================

	if ( typeof google !== 'undefined' ) {
		$( '.js-google-map' ).each( function() {
			const config = $( this ).data( 'config' );
			const { coords, ...options } = config;

			const map = new google.maps.Map( this, {
				center: coords,
				styles: mapStyles,
				...options,
			} );

			const marker = new google.maps.Marker( {
				position: map.getCenter(),
				icon: {
					// marker.svg
					path: 'M28,0.7c-15.4,0-28,12.6-28,28c0,23.9,25.4,42,26.5,42.8c0.9,0.6,2.1,0.6,3,0C30.6,70.8,56,52.7,56,28.7C56,13.3,43.5,0.7,28,0.7z M28,18.5c5.6,0,10.2,4.6,10.2,10.2S33.6,38.9,28,38.9s-10.2-4.6-10.2-10.2l0,0C17.8,23.1,22.4,18.5,28,18.5z',
					anchor: new google.maps.Point( 28, 72 ),
					fillColor: '#934054',
					fillOpacity: 1,
					strokeWeight: 0,
				},
			} );

			marker.setMap( map );
		} );
	}

	// =========================
	// ! VH Hack
	// =========================

	function setVH() {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty( '--vh', `${ vh }px` );
	}

	window.addEventListener( 'resize', setVH );
	setVH();

	// =========================
	// ! Bookmark Links
	// =========================

	$( 'a[rel="bookmark"]' ).click( e => e.preventDefault() );

	const hrefClipboard = new CliboardJS( 'a[rel="bookmark"]', {
		text( trigger ) {
			return trigger.getAttribute( 'href' );
		},
	} );

	hrefClipboard.on( 'success', e => {
		$( e.trigger ).addClass( 'js-copied' ).append( '<span class="js-tooltip">Link copied!</span>' );
	} );

	// =========================
	// ! Directory Module
	// =========================

	setupDirectoryModules();

	// =========================
	// ! Minilisting Module
	// =========================

	const mobileQuery = window.matchMedia( `(max-width: ${ 600 / 16 }em)` );
	const tabletQuery = window.matchMedia( `(max-width: ${ 1000 / 16 }em)` );

	$( '.js-minilisting' ).each( function() {
		const perPageDesktop = parseInt( this.dataset.perPage ?? 12 );
		const perPageTablet = parseInt( this.dataset.perPageTablet ?? Math.floor( perPageDesktop * .75 ) );
		const perPageMobile = parseInt( this.dataset.perPageMobile ?? Math.floor( perPageDesktop / 2 ) );
		let page = 0;

		const itemsWrap = this.querySelector( '.js-minilisting-items' );
		const items = [ ...itemsWrap.children ];
		const pagination = this.querySelector( '.js-pagination' );
		const currentIndicator = this.querySelector( '.js-pagination-current' );
		const totalIndicator = this.querySelector( '.js-pagination-total' );
		const dotHolder = this.querySelector( '.js-pagination-dots' );
		const prevButton = this.querySelector( '.js-pagination-prev' );
		const nextButton = this.querySelector( '.js-pagination-next' );

		let perPage = perPageDesktop;
		let maxPage = Math.ceil( items.length / perPage );
		let dots = [];

		function paginate() {
			const start = page * perPage;
			const end = start + perPage;

			items.forEach( ( item, index ) => {
				item.hidden = ! ( index >= start && index < end );
			} );

			if ( currentIndicator ) {
				currentIndicator.innerText = page + 1;
			}
			dots.forEach( ( dot, index ) => dot.classList.toggle( 'current', index === page ) );

			prevButton.disabled = page === 0;
			nextButton.disabled = page === maxPage - 1;
		}

		function resetPagination() {
			perPage = perPageDesktop;
			if ( tabletQuery.matches ) {
				perPage = perPageTablet;

				if ( mobileQuery.matches ) {
					perPage = perPageMobile;
				}
			}

			maxPage = Math.ceil( items.length / perPage );

			dots = [];
			if ( dotHolder ) {
				dotHolder.innerHTML = '';
				for ( let i = 0; i < maxPage; i++ ) {
					const dot = document.createElement( 'div' );
					dot.className = 'js-pagination-dot';
					dots.push( dot );
					dotHolder.append( dot );
				}
				dots[ 0 ].classList.add( 'current' );
			}

			pagination.hidden = items.length < perPage;
			if ( totalIndicator ) {
				totalIndicator.innerText = maxPage;
			}

			let template = '"';
			for ( let i = 0; i < perPage; i++ ) {
				template += `_${ i } `;
				if ( i === ( perPage / 2 ) - 1 ) {
					template += '" "';
				}
			}
			template += '"';
			itemsWrap.style.setProperty( '--columns', perPage / 2 );
			itemsWrap.style.setProperty( '--layout', template );

			items.forEach( ( item, index ) => {
				//item.style.setProperty( '--index', index % perPage );
				item.style.setProperty( '--position', `_${ index % perPage }` );
			} );

			page = 0;
			paginate();
		}

		resetPagination();
		if ( typeof tabletQuery.addEventListener === 'undefined' ) {
			tabletQuery.addListener( resetPagination );
		} else {
			tabletQuery.addEventListener( 'change', resetPagination );
		}
		if ( typeof mobileQuery.addEventListener === 'undefined' ) {
			mobileQuery.addListener( resetPagination );
		} else {
			mobileQuery.addEventListener( 'change', resetPagination );
		}

		prevButton.addEventListener( 'click', () => {
			page--;
			paginate();
		} );
		nextButton.addEventListener( 'click', () => {
			page++;
			paginate();
		} );
	} );

	// =========================
	// ! Stats/History Module
	// =========================

	const counterAnimations = new WeakMap();
	function animateCount( element, newNumber ) {
		if ( ! element ) {
			return;
		}

		const current = parseInt( element.innerText || '0' );
		if ( current === newNumber ) {
			return;
		}

		const previous = counterAnimations.get( element );
		if ( previous ) {
			previous.stop = true;
		}

		const delta = current > newNumber ? -1 : 1;
		const diff = Math.abs( current - newNumber );
		const start = performance.now();

		function step() {
			if ( step.stop || current === newNumber ) {
				return;
			}

			const elapsed = performance.now() - start;
			const progress = Math.min( elapsed / 500, 1 );

			element.innerText = Math.round( current + ( diff * progress * delta ) );

			if ( progress < 1 ) {
				requestAnimationFrame( step );
			}
		}
		requestAnimationFrame( step );
	}

	$( '.reach-stats-history' ).each( function() {
		const tabs = this.querySelectorAll( '.reach-stats-history__tab' );
		const visibles = this.querySelectorAll( '[data-stats-history-visible]' );
		const stats = this.querySelectorAll( '[data-stats-history-values]' );

		const visibleConfigs = new WeakMap();
		visibles.forEach( element => visibleConfigs.set( element, JSON.parse( element.dataset.statsHistoryVisible ) ) );

		const valueConfigs = new WeakMap();
		stats.forEach( element => valueConfigs.set( element, JSON.parse( element.dataset.statsHistoryValues ) ) );

		function updateContent( tab ) {
			tabs.forEach( element => element.setAttribute( 'aria-selected', tab === element.id ) );
			visibles.forEach( element => element.setAttribute( 'aria-hidden', ! visibleConfigs.get( element ).includes( tab ) ) );
			stats.forEach( element => {
				const value = valueConfigs.get( element )[ tab ] ?? 0;
				if ( element.dataset.statsHistorySingular ) {
					element.querySelector( '.reach-stat__label' ).innerText = value === 1 ? element.dataset.statsHistorySingular : element.dataset.statsHistoryPlural;
				}
				animateCount( element.querySelector( '.reach-stat__value' ), value );
			} );
		}

		this.addEventListener( 'click', event => {
			const tab = event.target.closest( '.reach-stats-history__tab' );
			if ( tab ) {
				event.preventDefault();
				updateContent( tab.id );
			}
		} );

		updateContent( ( this.querySelector( '.reach-stats-history__tab.default' ) || this.querySelector( '.reach-stats-history__tab' ) ).id );
	} );

	const statObserver = new IntersectionObserver( changes => {
		changes.forEach( change => {
			if ( change.isIntersecting && ! change.target.dataset.animating ) {
				change.target.dataset.animating = true;
				animateCount( change.target, parseInt( change.target.dataset.countup ) );
			}
		} );
	} );

	$( '.reach-stat__value[data-countup]' ).each( function() {
		this.innerHTML = '';
		statObserver.observe( this );
	} );

	// =========================
	// ! Mini-ruled Text Animation
	// =========================

	const miniruledTextObserver = new IntersectionObserver( changes => {
		changes.forEach( change => {
			if ( change.isIntersecting ) {
				change.target.classList.add( 'animate' );
			}
		} );
	} );

	$( '.is-style-miniruled' ).each( function() {
		$( this ).wrapInner( '<span class="miniruled-text-wrapper"><span class="miniruled-text"></span></span>' );
		miniruledTextObserver.observe( this );
	} );

	// =========================
	// ! Caption Stuff
	// =========================

	$( '[data-caption-content]' ).each( function() {
		const figcaption = document.createElement( 'figcaption' );
		figcaption.className = 'lazy-load-content';
		figcaption.innerText = this.dataset.captionContent;
		$( this ).append( figcaption );
	} );

	// =========================
	// ! Animation Toggle
	// =========================

	let ANIMATIONS_PAUSED = false;
	$( '.js-animation-toggle' ).click( function() {
		ANIMATIONS_PAUSED = ! ANIMATIONS_PAUSED;
		$body.toggleClass( 'animations-paused', ANIMATIONS_PAUSED );

		$( 'video' ).each( function() {
			if ( ANIMATIONS_PAUSED ) {
				this.pause();
				this.dataset.wasPaused = 1;
			} else if ( this.dataset.wasPaused ) {
				this.play();
			}
		} );
	} );

	// =========================
	// ! Filterable List Handling
	// =========================

	document.querySelectorAll( '.js-filterable' ).forEach( container => {
		const searchInput = container.querySelector( '.js-filterable-search' );
		const items = container.querySelectorAll( '.js-filterable-item' );

		function onSearch() {
			const query = searchInput.value.normalize( 'NFD' ).replace( /[\u0300-\u036f]/g, '' ).toLowerCase();

			items.forEach( item => {
				const value = item.dataset?.value ?? item.innerText ?? '';
				if ( query && ! value.includes( query ) ) {
					item.hidden = true;
				} else {
					item.hidden = false;
				}
			} );
		}

		searchInput?.addEventListener( 'input', debounce( onSearch, 500 ) );
	} );

	// =========================
	// ! Initialize Stuff
	// =========================

	$body.addClass( 'ready' );
} );
